import { useEffect } from "react";

const SITE = "https://nestledapp.io";
const DEFAULT_OG = "https://images.unsplash.com/photo-1631630259742-c0f0b17c6c10?w=1200&h=630&fit=crop&q=80";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (data == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * <SEO
 *   title="..."          (will be suffixed with " — Nestled")
 *   description="..."
 *   path="/features"     (canonical path)
 *   image="https://…"
 *   noindex={false}
 *   type="website|article"
 *   jsonLd={{...}}        custom JSON-LD object for this page
 * />
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  noindex = false,
  type = "website",
  jsonLd = null,
}) {
  useEffect(() => {
    const fullTitle = title ? `${title} — Nestled` : "Nestled — A place for everything";
    const url = `${SITE}${path}`;

    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", url);

    setMeta("property", "og:type", type);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    setJsonLd("nestled-page-jsonld", jsonLd);
  }, [title, description, path, image, noindex, type, jsonLd]);

  return null;
}
